var RecentViews = React.createClass({
  propTypes: {
    solutions: React.PropTypes.arrayOf(React.PropTypes.object)
  },
  render() {
    let {className} = this.props;
    className = classNames(className, {"bullet-list": className == undefined});

    return (
      <ul className={className} aria-hidden={!this.props.solutions.length}>
        {this.props.solutions.map((sol, i) =>
          <li key={i}>
            <a href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${sol.id}`}>{sol.title}</a>
          </li>
        )}
      </ul>
    )
  }
})